import React, { useReducer } from 'react'
import { Link, Switch, Route, useRouteMatch } from './routing';
import { View, TouchableOpacity, Text, Button } from 'react-native';
import Radio from './Radio.js';
import RadioButton from './RadioButton.js';
import GrammarTestReducer from './GrammarTestReducer.js';
import GrammarTestCorrectAnswer from './GrammarTestCorrectAnswer.js';
import GrammarTestWrongAnswer from './GrammarTestWrongAnswer.js';
import GrammarExplanation from './GrammarExplanation.js';
import GrammarHelperButton from './GrammarHelperButton.js';
import BaseContext from './BaseContext.js'
import { buildAnswers } from './Answers.js'
import Styles from './Styles.js'

let initialState = buildAnswers(new Set());

const GrammarTestQuestion = props => {
  return (
    <BaseContext.Consumer>
      {({state, dispatch}) => (
          <React.Fragment>
            <View style={Styles.grammarTestCasePromptContainer}>
              <Text style={Styles.grammarTestCasePromptText}>{state.prompt} <GrammarHelperButton size={24} onPress={() => dispatch({ type: 'SHOW_GRAMMAR_HELP' })} /></Text>
              <Text style={Styles.grammarTestCaseTranslationText}>{state.translation}</Text>
            </View>
            <View style={Styles.grammarTestCaseContainer}>
              <Radio>
                {state.allAnswers.map((answer) =>
                  <RadioButton key={answer} title={answer} id={answer} onPress={ () => dispatch(
                    { type: 'SELECT_ANSWER', answer: answer }
                  )} />
                )}
              </Radio>
            </View> 
          </React.Fragment>
        )
      }
    </BaseContext.Consumer>
  )
}

const GrammarTestCase = props => {
  const [state, dispatch] = useReducer(GrammarTestReducer, initialState)

  let child = {}

  if(state.showGrammarHelp){
    child = <GrammarExplanation />
  }
  else if(state.checkAnswers){
    if(state.selectedAnswer == state.correctAnswer){
      child = <GrammarTestCorrectAnswer />
    }
    else{
      child = <GrammarTestWrongAnswer />
    }
  }
  else{
    child = <GrammarTestQuestion state={state} dispatch={dispatch} />
  }

  return (
    <BaseContext.Provider value={{state: state, dispatch: dispatch}}>
      {child}
    </BaseContext.Provider>
  )
}
export default GrammarTestCase
